import React from 'react';
import { UserProvider, useUserContext } from './context';
import UserProfileHeader from './UserProfileHeader';
import UserPublicEntities from './UserPublicEntities';
import './index.scss';

function UserContainer() {
  return (
    <UserProvider>
      <User />
    </UserProvider>
  );
}

function User() {
  return (
    <div className="user-profile">
      <UserProfileHeader />
      <UserPublicEntities />
    </div>
  );
}

export default UserContainer;
